import axios from "axios";

export const getStrutturaTopicsApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/topics/struttura/`)
}

export const downloadTemplateTopics = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/topics/template-import/`)
}